// V9.8 · Família na tela — irmãos do aluno (responsáveis em comum), 1 clique para alternar
import React, { useCallback, useEffect, useState } from 'react';
import { Users, ArrowRightLeft } from 'lucide-react';

const API_URL = window.location.origin;

const FamiliaBar = ({ studentId, studentName, onSelect }) => {
  const [data, setData] = useState(null);

  const load = useCallback(async () => {
    if (!studentId) return;
    try {
      const r = await fetch(`${API_URL}/api/guardians/student/${studentId}/family`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      if (!r.ok) return;
      setData(await r.json());
    } catch { /* bloco secundário: nunca derruba a tela */ }
  }, [studentId]);

  useEffect(() => { load(); }, [load]);

  const siblings = data?.siblings || [];
  if (siblings.length === 0) return null;

  return (
    <div className="rounded-2xl border border-violet-100 bg-violet-50/60 px-4 py-3" data-testid="familia-bar">
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-[11px] font-bold uppercase tracking-wider text-violet-700 inline-flex items-center gap-1.5">
          <Users className="h-3.5 w-3.5" /> Família · {siblings.length} irmão(s) na escola
        </span>
        <span className="text-[11px] text-slate-500">{studentName}</span>
        <div className="ml-auto flex flex-wrap items-center gap-1.5">
          {siblings.map((s) => (
            <button key={s.id} type="button" onClick={() => onSelect?.(s)}
              title={`Abrir ${s.name}${s.via?.length ? ` · responsável em comum: ${s.via.join(', ')}` : ''}`}
              className="group inline-flex items-center gap-1.5 rounded-xl border border-violet-200 bg-white px-2.5 py-1.5 text-left transition-colors hover:border-violet-400 hover:bg-violet-50"
              data-testid={`familia-irmao-${s.id}`}>
              <span className="flex h-6 w-6 items-center justify-center rounded-lg bg-violet-100 text-[10px] font-bold text-violet-700">
                {(s.name || '?').slice(0, 1).toUpperCase()}
              </span>
              <span className="min-w-0">
                <span className="block max-w-[170px] truncate text-[11.5px] font-bold text-slate-800">{s.name}</span>
                <span className="block text-[10px] text-slate-500">
                  {s.class_name || s.situation || 'sem turma'}
                </span>
              </span>
              <ArrowRightLeft className="h-3 w-3 text-violet-400 opacity-0 transition-opacity group-hover:opacity-100" />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FamiliaBar;
